import { Helmet } from "react-helmet-async";

const SITE = "Bottom Line Improvements";

export default function Seo({ title, description, path }) {
  const full = title ? `${title} — ${SITE}` : `${SITE} — Helping Good Businesses Keep More of What They Earn`;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      {path ? <link rel="canonical" href={typeof window !== "undefined" ? `${window.location.origin}${path}` : path} /> : null}
    </Helmet>
  );
}
